<script>
import Nav from "@/components/Nav/index.vue";
export default {
    name: "Benefits",
    components: {
        Nav,
    },
    data() {
        return {
            popup: false,
        };
    },
    mounted() {
        this.popup = false;
    },
    methods: {
        sendGtm(str) {
            window.dataLayer.push({
                event: "horyuken_event",
                event_name: str,
                event_time: new Date().toLocaleString(),
            });
        },
        closePopup() {
            this.popup = false;
        },
    },
};
</script>
<template src="./template.pug" lang="pug"></template>
<style src="./style.sass" lang="sass" scoped></style>
